module.exports = __webpack_public_path__ + "img/fee.4ded8b12.png";